/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { InquiryDto } from '../../models/inquiry-dto';
import { PageInfoDto } from '../../models/page-info-dto';

export interface InquiryControllerSearchMyInquiries$Params {

/**
 * 페이지 크기
 */
  pageSize: number;

/**
 * 정렬 기준
 */
  orderBy?: string;

/**
 * 정렬 방향
 */
  align?: 'asc' | 'desc';

/**
 * 검색어
 */
  query?: string;

/**
 * 페이지 번호
 */
  pageNo: number;

/**
 * 작성자 ID
 */
  userId?: string;

/**
 * 문의 유형
 */
  inquiryType?: 'PRODUCT' | 'ORDER_PAYMENT' | 'REFUND' | 'SETTLEMENT' | 'MEMBER_INFO' | 'OTHER';

/**
 * 답변 상태 필터 (answered / unanswered)
 */
  answerStatus?: string;
}

export function inquiryControllerSearchMyInquiries(http: HttpClient, rootUrl: string, params: InquiryControllerSearchMyInquiries$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'items': Array<InquiryDto>;
'pageInfo': PageInfoDto;
}>> {
  const rb = new RequestBuilder(rootUrl, inquiryControllerSearchMyInquiries.PATH, 'get');
  if (params) {
    rb.query('pageSize', params.pageSize, {});
    rb.query('orderBy', params.orderBy, {});
    rb.query('align', params.align, {});
    rb.query('query', params.query, {});
    rb.query('pageNo', params.pageNo, {});
    rb.query('userId', params.userId, {});
    rb.query('inquiryType', params.inquiryType, {});
    rb.query('answerStatus', params.answerStatus, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      'items': Array<InquiryDto>;
      'pageInfo': PageInfoDto;
      }>;
    })
  );
}

inquiryControllerSearchMyInquiries.PATH = '/api/inquiry/my';
